import { registerCrudStore } from '@/libs/core/+state/register-crud-store';
import { ProductModel } from '@/libs/Api';
import { ProductsDataService } from '@/libs/products/products-data-service';
import { BusinessModule } from '@/libs/core/models/business-module';

export const productsStore = registerCrudStore<ProductModel, ProductModel>(BusinessModule.Product, new ProductsDataService());
